angular.module('app.directives').directive('isDeleted', () => ({
    restrict: 'E',

    scope: {
        model: '=model',
    },

    controller($scope) {
        $scope.$watch('model._deleted', (value) => {
            $scope.isDeleted = value;
        });
    },

    template: [
        '<span ng-class="{\'uk-text-danger\': isDeleted}">',
        '<em class="material-icons md-24" ng-show="isDeleted">delete</em> &nbsp;',
        '<ng-transclude></ng-transclude>',
        '</span>',
    ].join(''),

    transclude: true,
}));
